import { createContext, useContext } from "react";
import { SessionGetResponse, StaticCurrency, StatusGetResponse, ExchangeRatesGetResponse } from "./ApiClient/models";

interface AppContextState {
    session: SessionGetResponse | null;
    refreshSession: () => void;
    currencies: StaticCurrency[] | null;
    activeCurrency: string | null;
    setActiveCurrency: (currencyCode: string) => void;
    status: StatusGetResponse[] | null;
    refreshStatus: () => void;
    exchangeRates: ExchangeRatesGetResponse[] | null;
    refreshExchangeRates: () => void;
}

export const AppContext = createContext<AppContextState>({
    session: null,
    refreshSession: () => { },
    currencies: null,
    activeCurrency: null,
    setActiveCurrency: (_currencyCode: string) => { },
    status: null,
    refreshStatus: () => { },
    exchangeRates: null,
    refreshExchangeRates: () => { }
});

export function useApp() {
    return useContext(AppContext);
}